import React from 'react';
import { I18n } from 'aws-amplify';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import clipboard from 'clipboard';
import PremiumIcon from './premiumIcon.png';

new clipboard('.mierukaPRContentCopyButton');

const ContentBlock = (props) => {
  const str = '?mwid='+props.contentBody.mierukaWebId;
  return(
    <div className="mierukaContentblock">
      <dt className="mierukaItemHeader">
        <p className='mierukaPRContentName'>
          {props.contentBody.isPremium ? <img className='mierukaPremiumIcon' src={PremiumIcon} alt='P' /> : <span />}
          <span className='mierukaPRContentName'>{props.contentBody.str}</span>
        </p>
      </dt>
      <dd class="mypageUserinfoItemData">
        <Button
          className="mierukaPRContentCopyButton gray"
          onClick = {() => props.openSnack(props.contentBody.str)}
          data-clipboard-text={props.contentBody.urlStr}
        >
          {I18n.get('Copy URL')}
        </Button>
        <a className="mypageNormalButton blueBorder" target="_blank" rel="noopener noreferrer" href={props.contentBody.urlStr}>{I18n.get('Show')}</a>

        <Link className="mypageNormalButton blue" to={{
          pathname: '/mierukacruise',
          search: str,
        }}>
          {I18n.get('Edit')}
        </Link>
      </dd>
    </div>
  )
}
export default ContentBlock;